import { useState, useCallback } from "react";
import { useApiClient } from "../../../api";

export const useQuizGroup = (quizGroupId) => {
  const ApiClient = useApiClient();

  const [quizGroup, setQuizGroup] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchQuizGroup = useCallback(
    async ({ initialLoad = false } = {}) => {
      if (!quizGroupId) return;

      try {
        if (initialLoad) {
          setLoading(true);
        }
        setError(null);

        const response = await ApiClient.quiz.getQuizGroup({
          quizGroup: quizGroupId,
        });

        if (response?.quizGroup) {
          setQuizGroup(response.quizGroup);
        }
      } catch (err) {
        console.error("Failed to fetch quiz group", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [ApiClient, quizGroupId],
  );

  return {
    quizGroup,
    setQuizGroup,
    loading,
    error,
    fetchQuizGroup,
  };
};
